import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {CxSeverityColor} from './CxColor';

export function CxConfirmDialog({ open, title, text, handleConfirm, severity="Info" }) {
    const color = CxSeverityColor[severity];
    return (
        <Dialog
            open={open}
            onClose={() => handleConfirm("no")}                 // Defaults to "no" on backdrop click
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-dialog-description">{text}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleConfirm("no")} variant="outlined">
                    Nein
                </Button>
                <Button onClick={() => handleConfirm("yes")} variant="contained" color={color}>
                    Ja
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function CxInfoDialog({ open, title, content, handleInfo }) {
    return (
        <Dialog
            open={open}
            onClose={() => handleInfo("close")}                 // Defaults to "no" on backdrop click
            aria-labelledby="info-dialog-title"
            aria-describedby="info-dialog-description"
        >
            <DialogTitle id="info-dialog-title">{title}</DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleInfo("close")} variant="contained">
                    Schliessen
                </Button>
            </DialogActions>
        </Dialog>
    );
}
